<template>
  <div class="container py-4">
    <div class="row mb-3 align-items-center">
      <div class="col-md-9">
        <h4 class="font-weight-bold">
          Attendance - {{ formatDisplayDate(selectedDate) }}
        </h4>
      </div>
      <div class="col-md-3">
        <date-range-picker
          :auto-apply="true"
          :ranges="false"
          :single-date-picker="true"
          v-model="dateRange"
          class="custom-width-datepicker"
          @update="onDateChange"
        >
          <template #input="picker">
            <p v-if="picker.startDate">
              {{ formatDisplayDate(picker.startDate) }}
            </p>
            <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
          </template>
        </date-range-picker>
      </div>
    </div>

    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div v-else>
      <b-table
        hover
        responsive
        :items="attendance"
        :fields="fields"
        class="mt-3"
        small
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(check_in)="data">
          <span v-if="data.item.check_in">{{ formatTime(data.item.check_in) }}</span>
          <span v-else class="text-muted">—</span>
        </template>

        <template #cell(check_out)="data">
          <span v-if="data.item.check_out">{{ formatTime(data.item.check_out) }}</span>
          <span v-else class="text-muted">—</span>
        </template>

        <template #cell(device)="data">
          <span>{{ data.item.device || '—' }}</span>
        </template>
      </b-table>

      <div v-if="attendance.length === 0" class="text-center mt-4 text-muted">
        No attendance records found for {{ formatDisplayDate(selectedDate) }}.
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
import axios from "axios";
import moment from "moment";

export default {
  name: "Attendance",
  components: { DateRangePicker },
  data() {
    return {
      attendance: [],
      pagination: {}, // To store pagination info if needed
      loading: false,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      selectedDate: "",
      fields: [
        { key: "index", label: "#", sortable: false },
        { key: "name", label: "Employee", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "check_in", label: "Check-in", sortable: false },
        { key: "check_out", label: "Check-out", sortable: false },
        { key: "device", label: "Device", sortable: false },
      ],
    };
  },
  methods: {
    initializeDate() {
      const params = new URLSearchParams(window.location.search);
      const queryDate = params.get("date");
      const fallback = moment().format("YYYY-MM-DD");

      this.selectedDate = queryDate || fallback;
      this.dateRange.startDate = this.selectedDate;
      this.dateRange.endDate = this.selectedDate;
    },
    updateUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set("date", this.selectedDate);
      window.history.replaceState({}, "", url.toString());
    },
    fetchAttendance() {
      this.loading = true;
      axios
        .get("/api/attendance-logs", {
          params: { date: this.selectedDate },
        })
        .then((res) => {
          this.attendance = res.data.data; // important
          this.pagination = res.data.pagination || {};
        })
        .catch((err) => {
          console.error(err);
          this.$toasts?.push({
            type: "danger",
            message: "Failed to load attendance data.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDateChange() {
      if (this.dateRange.startDate) {
        this.selectedDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.updateUrl();
        this.fetchAttendance();
      }
    },
    formatTime(datetime) {
      return moment(datetime).format("HH:mm:ss");
    },
    formatDisplayDate(date) {
      return moment(date).format("dddd, MMMM D, YYYY");
    },
  },
  mounted() {
    this.initializeDate();
    this.fetchAttendance();
  },
};
</script>

<style scoped>
.custom-width-datepicker {
  width: 100% !important;
}
</style>
